// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._19bv1b66{padding-left:var(--ds-space-050,4px)}
._u5f31b66{padding-right:var(--ds-space-050,4px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/EmbedCard/views/ErroredView.compiled.css"],"names":[],"mappings":"AAAA,WAAW,oCAAoC;AAC/C,WAAW,qCAAqC","sourcesContent":["._19bv1b66{padding-left:var(--ds-space-050,4px)}\n._u5f31b66{padding-right:var(--ds-space-050,4px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
